import { styled } from "@mui/system";
import Carousel from "react-material-ui-carousel";

export const StyledCarousel = styled(Carousel)({
  borderRadius: 32,
  width: "100%",
});
